import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { selectHistoryView, setHistoryView } from "./slice"
import { IconButton } from "@nova/component-btn"
import * as Icons from "@nova/component-icons"

export const PilotHistoryTabSwitcher = () => {
    const dispatch = useAppDispatch()
    const view = useAppSelector(selectHistoryView)
    return (
        <div className="flex items-center gap-2.5">
            <h5 className="text-gray-400">View</h5>
            <div className="flex items-center gap-1.5">
                <IconButton
                    className="data-[active=true]:text-white data-[active=true]:bg-gray-700 rounded-md p-1 text-gray-500"
                    data-active={`${view === "table"}`}
                    onClick={() => dispatch(setHistoryView("table"))}
                >
                    <Icons.SmallIcon Icon={Icons.List} />
                </IconButton>
                <IconButton
                    className="data-[active=true]:text-white data-[active=true]:bg-gray-700 rounded-md p-1 text-gray-500"
                    data-active={`${view === "map"}`}
                    onClick={() => dispatch(setHistoryView("map"))}
                >
                    <Icons.SmallIcon Icon={Icons.BlurOn} />
                </IconButton>
            </div>
        </div>
    )
}
